import { useEffect, useState } from 'react';
import { getPage } from '@/services/privacy-policy-page/privacy-policy-page.service';
import type { PrivacyPolicyPage } from '@edwin-group/cj-graphql/generated/graphql';
import DefaultContentTemplatePage from '../default-content-template';
import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';

const PrivacyPolicyPageComponent = () => {
  const [page, setPage] = useState<PrivacyPolicyPage | null>(null);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    (async () => {
      setLoading(true);

      const pageResponse = await getPage();

      setPage(pageResponse.page);
      setLoading(false);
    })();
  }, []);

  const template = page?.DefaultContentTemplate || null;

  if (loading) {
    return null;
  }

  return (
    <Container>
      <SubContainer>
        <DefaultContentTemplatePage template={template} title={page?.title || 'Back to the Homepage'} />
      </SubContainer>
    </Container>
  );
};

export default PrivacyPolicyPageComponent;
